import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Layout, Space, Spin } from "antd";
import { URL } from "../00_Nav/url";
//components
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import IncomeByStaffTopbar from "./component/income_by_staff_topbar";
import IncomeByStaffTable from "./component/income_by_staff_table";

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  branchSelector,
  incomeSelector,
  userInfoSelector,
} from "../../store/incomeStaff/incomeStaff.selector";
import {
  snapAllIncomeByDate,
  unSnapIncome,
  getAllBranch,
  getUserInfo,
} from "../../store/incomeStaff/incomeStaff.action";

//style
import "./style.css";
import moment from "moment";
import lodash from "lodash";
import { getData } from "./function/get_data";
import LayoutFooter from "../00_Nav/layout/layout_footer";

const { Content } = Layout;

const CashupIncomeByStaff = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Report", url: URL.report },
    { title: "Income by staff", url: URL.incomeByStaff },
  ];
  // -------------------------- STATE --------------------------
  const [search, setSearch] = useState("All");
  const [from, setFrom] = useState(moment().startOf("week"));
  const [to, setTo] = useState(moment().endOf("week"));

  const [loadingData, setLoadingData] = useState(true);
  const [loadingInfo, setLoadingInfo] = useState(true);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const incomeStaff = useSelector(incomeSelector);
  const branches = useSelector(branchSelector);
  const users = useSelector(userInfoSelector);
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (from && to) {
      dispatch(snapAllIncomeByDate({ from, to }, () => setLoadingData(false)));
    }

    return () => dispatch(unSnapIncome());
  }, [from, to]);

  useEffect(() => {
    let branchIdList = [];
    let userIdList = [];
    incomeStaff?.forEach((item) => {
      branchIdList.push(item.branch);
      item.staffs.forEach((staff) => {
        userIdList.push(staff.userId);
      });
    });
    const uniqBranchList = lodash.uniq(branchIdList);
    const uniqUserList = lodash.uniq(userIdList);
    console.log({uniqUserList});
    dispatch(getAllBranch({ branchIdList: uniqBranchList }));
    dispatch(
      getUserInfo({ userIdList: uniqUserList }, () => setLoadingInfo(false))
    );
  }, [incomeStaff]);

  // -------------------------- RENDER --------------------------
  const data = incomeStaff ? getData(incomeStaff, branches, users) : [];

  const reportData =
    search !== "All" ? data?.filter((item) => item.full_name === search) : data;

  const uniqArray = lodash.uniq(reportData?.map((item) => item.full_name));
  const options = [
    ...[{ label: "All Staffs", value: "All" }],
    ...(uniqArray?.map((staff) => {
      const option = {
        label: staff,
        value: staff,
      };
      return option;
    }) || []),
  ];

  const renderBody = () => {
    if (reportData) {
      return (
        <Row style={{ margin: "20px 0px" }}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <IncomeByStaffTopbar
              search={search}
              setSearch={setSearch}
              from={from}
              setFrom={setFrom}
              to={to}
              setTo={setTo}
              options={options}
            />
          </Col>
          <Col style={{ marginTop: 10 }} xl={24} lg={24} md={24} xs={24}>
            <IncomeByStaffTable reportData={reportData} />
          </Col>
        </Row>
      );
    }
    return (
      <Space
        direction="vertical"
        style={{
          marginTop: 200,
          width: "100%",
        }}
      >
        <Spin tip="Loading table data..." size="small">
          <div className="content" />
        </Spin>
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default CashupIncomeByStaff;
